export class AsyncTask {
    task;
    resolveTask;
    rejectTask;
    completed = false;
    constructor(timeout) {
        this.task = new Promise((resolve, reject) => {
            this.resolveTask = resolve;
            this.rejectTask = reject;
        });
        if (timeout) {
            const timer = setTimeout(() => {
                this.reject(new Error(`AsyncTask timeout after ${timeout}ms!`));
            }, timeout);
            this.waitUntilResolved()
                .then(() => clearTimeout(timer))
                .catch(() => clearTimeout(timer));
        }
    }
    resolve(value) {
        if (this.completed) {
            return;
        }
        this.completed = true;
        this.resolveTask(value);
    }
    reject(err) {
        if (this.completed) {
            return;
        }
        this.completed = true;
        this.rejectTask(err);
    }
    waitUntilResolved() {
        return this.task;
    }
}
//# sourceMappingURL=async-task.js.map